/**
 * Reine Scope-Ableitung fuer die ZEO-Vollbildseite -- bewusst OHNE jeden
 * React-/Router-Import, damit diese sicherheitsrelevante Funktion isoliert
 * (auch unter Jest, ohne react-router-dom-Modulaufloesungsprobleme)
 * getestet werden kann.
 */
/**
 * ZEO interaktive Antworten (06.10.2026, Abschnitt 2): zerlegt eine lange
 * ZEO-Antwort in einzeln referenzierbare Bloecke (deterministisch anhand
 * nummerierter Listenpunkte bzw. Absaetze -- v1-Heuristik, kein echtes NLU).
 * Jeder Block bekommt eine stabile block_id ("<message_id>:<index>"), damit
 * ein Reply exakt auf diesen einen Punkt zeigen kann statt auf die gesamte
 * Nachricht.
 */
export function zerlegeInBloecke(messageId, text) {
  if (!text || !text.trim()) return [];
  const zeilen = text.split(/\n+/).map((z) => z.trim()).filter(Boolean);
  const bloecke = [];
  let aktuell = null;

  const istNeuerBlock = (zeile) => /^(\d+[.)]|[-*])\s+/.test(zeile);

  for (const zeile of zeilen) {
    if (istNeuerBlock(zeile) || aktuell === null) {
      if (aktuell) bloecke.push(aktuell);
      aktuell = zeile;
    } else {
      aktuell += `\n${zeile}`;
    }
  }
  if (aktuell) bloecke.push(aktuell);

  // Nur in echte Bloecke zerlegen, wenn es mehrere gibt -- eine einzelne,
  // kurze Antwort bleibt EIN Block (die ganze Nachricht ist dann ohnehin
  // das sinnvolle Reply-Ziel).
  if (bloecke.length <= 1) return [];

  return bloecke.map((text, index) => ({
    block_id: `${messageId}:${index}`,
    display_text: text,                  // VOLLSTAENDIGER Text -- nie fuer die Anzeige kuerzen (Ursache der abgeschnittenen Antworten, 08.10.2026)
  }));
}

export function scopeAusParams(searchParams) {
  const scopeParam = searchParams.get('scope');
  const klientId = searchParams.get('klient_id');
  if (scopeParam === 'client' && klientId) {
    return { scope: 'client', kontext_typ: 'betreuungsakte', kontext_id: klientId };
  }
  // Fail-safe: jeder nicht eindeutige/unbekannte Parameter faellt auf
  // Buero-Scope zurueck -- NIE eine erfundene klient_id.
  return { scope: 'office', kontext_typ: 'office', kontext_id: '' };
}
